<menu>
  <div class="menu-style menuFixed" (mouseleave)="openMenu('all')" (window:scroll)="scrolling()" (click)="Globals.checkRoute()">

    <!--<div class="close_menu" (click)="toggleVisibility()">
              <div class="nav-trigger" [ngClass] = "{'nav-trigger-show': visibility=='shown','nav-trigger-hide': visibility!='shown'}"></div>
            </div> -->

    <div class="menu-lines"></div>

    <!-- свернутое меню-->
    <div (mouseenter)="openMenu('main')" (mouseleave)="openMenu('main')" class="menu-item" [routerLink]="['/main']"
      routerLinkActive="active-link">
      <div class="icon-box">
        <span class='m-icon-home'></span>
      </div>
    </div>
    <div class="menu-item-add" (mouseenter)="openMenu('main')" (mouseleave)="openMenu('main')"></div>

    <div *ngIf="checkUser('stat')" (mouseenter)="openMenu('stat')" class="menu-item" routerLinkActive="active-link">
      <div class="icon-box">
        <span class='m-icon-list-s'></span>
      </div>
      <span [routerLink]="['/report/sensor-statistics']"></span>
      <span [routerLink]="['/report/consolidated-statistics']"></span>
      <span [routerLink]="['/report/consolidated-statistics-gk']"></span>
    </div>
    <div *ngIf="checkUser('stat')" class="menu-item-add"></div>

    <div *ngIf="checkUser('events')" (mouseenter)="openMenu('events')" class="menu-item" routerLinkActive="active-link">
      <div class="icon-box">
        <span class='m-icon-list-e'></span>
      </div>
      <span [routerLink]="['/report/sensor-events']"></span>
      <span [routerLink]="['/report/consolidated-events']"></span>
      <span [routerLink]="['/report/all-events']"></span>
    </div>
    <div *ngIf="checkUser('events')" class="menu-item-add"></div>

    <div *ngIf="checkUser('tracking')" (mouseenter)="openMenu('track')" (mouseleave)="openMenu('track')"
      class="menu-item" [routerLink]="['/tracking']" routerLinkActive="active-link">
      <div class="icon-box"><span class='m-icon-car'></span></div>
    </div>
    <div *ngIf="checkUser('tracking')" class="menu-item-add" (mouseenter)="openMenu('track')"
      (mouseleave)="openMenu('track')"></div>

    <div *ngIf="checkUser('analisis')" (mouseenter)="openMenu('anal')" (mouseleave)="openMenu('anal')" class="menu-item"
      routerLinkActive="active-link">
      <div class="icon-box">
        <span class='m-icon-analisis'></span>
      </div>
      <span [routerLink]="['/report/sensor-primary-report']"></span>
      <span [routerLink]="['/admin/admin-sensors-test']"></span>
      <span [routerLink]="['/report/status-diagram']"></span>
    </div>
    <!-- /свернутое меню-->

    <!-- новое развернутое меню -->
    <!-- открытый блок пункта Главная -->
    <div class="menu-hover-open" [ngClass]="{'shown': show_main, 'hidden' : !show_main}">
      <div class="menu-hover-open-header">{{'mainPage' | translate}}</div>
      <div class="menu-hover-open-text">{{'menu_main_text' | translate}}</div>
    </div>
    <!-- открытый блок пункта Главная -->

    <!-- открытый блок пункта Статистика -->
    <div (mouseleave)="openMenu('stat')" class="menu-hover-open"
      [ngClass]="{'shown': show_stat, 'hidden' : !show_stat}">
      <div class="menu-hover-open-header">{{ 'statistics' | translate }}</div>

      <a class="sub-item">
        <div class="sub-item-icon"></div>
        <div class="sub-item-text" [routerLink]="['/report/sensor-statistics']" routerLinkActive="sub-item-text-active">
          {{ 'sensorReportStat' | translate }}</div>
      </a>

      <a class="sub-item">
        <div class="sub-item-icon"></div>
        <div class="sub-item-text" [routerLink]="['/report/consolidated-statistics']" routerLinkActive="sub-item-text-active">
          {{ 'consolidatedReportStat' | translate }}
          <span [routerLink]="['/report/consolidated-statistics-gk']"></span>
        </div>
      </a>

      <div class="menu-hover-open-text">{{ 'menu_stat_text' | translate }}</div>
    </div>
    <!-- /открытый блок пункта Статистика -->

    <!-- открытый блок пункта События -->
    <div (mouseleave)="openMenu('events')" class="menu-hover-open"
      [ngClass]="{'shown': show_events, 'hidden' : !show_events}">
      <div class="menu-hover-open-header">{{ 'events' | translate }}</div>

      <a class="sub-item">
        <div class="sub-item-icon"></div>
        <div class="sub-item-text" [routerLink]="['/report/sensor-events']" routerLinkActive="sub-item-text-active">
          {{ 'sensorReportEvent' | translate }}</div>
      </a>

      <a class="sub-item">
        <div class="sub-item-icon"></div>
        <div class="sub-item-text" [routerLink]="['/report/consolidated-events']" routerLinkActive="sub-item-text-active">
          {{ 'consolidatedReportEvent' | translate }}
        </div>
      </a>

      <a class="sub-item allEventsOn">
        <div class="sub-item-icon"></div>
        <div class="sub-item-text" [routerLink]="['/report/all-events']" routerLinkActive="sub-item-text-active">
          {{ 'allEvents' | translate }}
        </div>
      </a>

      <div class="menu-hover-open-text">{{ 'menu_events_text' | translate }}</div>
    </div>
    <!-- /открытый блок пункта События -->

    <!-- открытый блок пункта Трекирование
    <div class="menu-hover-open" [ngClass]="{'shown': show_track, 'hidden' : !show_track}">
      <div class="menu-hover-open-header">{{ 'vehicleTracking' | translate }}</div>
      <div class="menu-hover-open-text">{{ 'menu_tracking_text' | translate }}</div>
    </div>
     /открытый блок пункта Трекирование -->

    <!-- открытый блок пункта Анализ -->
    <div (mouseleave)="openMenu('anal')" class="menu-hover-open"
      [ngClass]="{'shown': show_anal, 'hidden' : !show_anal}">
      <div class="menu-hover-open-header">{{ 'primary_data_analysis' | translate }}</div>


      <a class="sub-item" *ngIf="Globals?.user?.role?.roles_id == Globals?.superadmin">
        <div class="sub-item-icon"></div>
        <div class="sub-item-text" [routerLink]="['/admin/admin-sensors-test']" routerLinkActive="sub-item-text-active">
          {{ 'monitoring' | translate }}</div>
      </a>

      <a class="sub-item">
        <div class="sub-item-icon"></div>
        <div class="sub-item-text" [routerLink]="['/report/sensor-primary-report']" routerLinkActive="sub-item-text-active">
          {{ 'sensor_analysis' | translate }}</div>
      </a>
      <a class="sub-item">
        <div class="sub-item-icon"></div>
        <div class="sub-item-text" [routerLink]="['/report/status-diagram']" routerLinkActive="sub-item-text-active">
          {{ 'status_diagram' | translate }}</div>
      </a>

      <div class="menu-hover-open-text">{{ 'menu_anal_text' | translate }}</div>
    </div>
    <!-- /открытый блок пункта Анализ -->

    <!-- /новое развернутое меню -->

  </div>
</menu>
